/**
 *
 * TreatmentPlan
 *
 */
import {useCallback, useEffect, useMemo, useState} from "react";
import * as PropTypes from "prop-types";
import styled from "styled-components";
import {WarningMessages} from "basicComponents/FormComponents/FormComponents";
import TreatmentList from "components/TreatmentList/TreatmentList";
import SimpleSearch from "basicComponents/SimpleSearch/SimpleSearch";
import messages from "./messages";
import {FormattedMessage} from "react-intl";
import GlobalMessages from "../../messages/messages";
import Match from "../../images/MatchIcon";
import NoMatch from "../../images/NoMatchIcon";
import {styling} from "styling";
import SingleSelectComponent from "components/SingleSelectComponent/SingleSelectComponent";

const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_8 = 8;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_10 = 10;
const REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11 = 11;
const TRY_IN_FIXATING_CLIPS_PLACEMENT_14 = 14;
const INTRA_ORAL_SCAN_AND_BITE_REGISTRATION = 15;

export function checkDropdown(treatmentPlan, treatments) {
  if (!treatmentPlan) {
    return true;
  }
  return !treatments.find(treatment => treatment.planned);
}

export function TreatmentPlan(props) {
  const {
    upperEndProductId,
    upperProductTypes,
    lowerEndProductId,
    lowerProductTypes,
  } = props;
  const [searchTextUpper, setSearchTextUpper] = useState("");
  const [searchTextLower, setSearchTextLower] = useState("");

  const shouldShowDropDown = checkDropdown(
    props.treatmentPlan,
    props.treatments,
  );

  const handleSearchTextUpperChanged = useCallback(value => {
    setSearchTextUpper(value.toLowerCase());
  }, []);

  const handleSearchTextLower2Changed = useCallback(value => {
    setSearchTextLower(value.toLowerCase());
  }, []);

  const match =
    props.upperIndex === props.lowerIndex ||
    props.upperIndex === -1 ||
    props.lowerIndex === -1;

  // Filter the list of upper end products
  const [upperEndProducts, upperIndex] = useMemo(
    () => {
      // Filter the list.
      const list = upperProductTypes.filter(plan =>
        plan.description.toLowerCase().includes(searchTextUpper),
      );
      // Get the active index
      const index = list.findIndex(plan => plan.id === upperEndProductId);

      return [list.map(plan => plan.description), index];
    },
    [searchTextUpper, upperEndProductId, upperProductTypes],
  );

  // Filter the list of lower end products
  const [lowerEndProducts, lowerIndex] = useMemo(
    () => {
      // Filter the list.
      const list = lowerProductTypes.filter(plan =>
        plan.description.toLowerCase().includes(searchTextLower.toLowerCase()),
      );
      // Get the active index
      const index = list.findIndex(plan => plan.id === lowerEndProductId);

      return [list.map(plan => plan.description), index];
    },
    [lowerProductTypes, lowerEndProductId, searchTextLower],
  );

  const shouldShowTreatmentList =
    lowerIndex !== -1 && upperIndex !== -1 && props.treatments.length > 0;

  const showIcon = lowerIndex !== -1 || upperIndex !== -1;

  const [width, setWidth] = useState(window.innerWidth);

  const small = width < styling.breakpointNumbers.desktopSmall;

  // Resize event listener
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return function cleanup() {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showLowerImplants = useMemo(
    () => {
      const lowerProduct = lowerProductTypes.find(
        x => x.id === lowerEndProductId,
      );

      return lowerProduct && lowerProduct.implant;
    },
    [lowerProductTypes, lowerEndProductId],
  );

  const showUpperImplants = useMemo(
    () => {
      const upperProduct = upperProductTypes.find(
        x => x.id === upperEndProductId,
      );

      return upperProduct && upperProduct.implant;
    },
    [upperProductTypes, upperEndProductId],
  );

  function MapTime(counts, times, value){
    for(var i = counts.length - 1; i >= 0; i--){
        if(value >= counts[i]){
            return times[i];
        }
    }
    return times[0];
  }
  //here
  const treatments = useMemo(
    () => {
      const treatmentList = props.treatments || [];
      const implantCount = (props.lowerImplantCount === undefined ? 0 : props.lowerImplantCount) + (props.upperImplantCount === undefined ? 0 : props.upperImplantCount);
      const extraHomeShippingTime =
        props.treatment && props.treatment.homeShipping ? 15 : 0;

      return treatmentList.map(treatment => {

        const treatmentId = treatment.createdAt > 0 ? treatment.treatmentId : treatment.id;
        

        if(treatmentId == 18){//rebasing
          let rebasecount = 0
          if(props.upperEndProductId == 13){
            rebasecount++;
          }
          if(props.lowerEndProductId == 13){
            rebasecount++;
          }
          let rebasedurations = [60,45,70]
          return {
            ...treatment,
            duration:rebasedurations[rebasecount]
          }
        }else if ([REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_8, REFERENCE_DENTURE_AND_INTRA_ORAL_SCAN_11, INTRA_ORAL_SCAN_AND_BITE_REGISTRATION].includes(treatmentId)) {
          return {
            ...treatment,
            duration:
              +treatment.duration +
              MapTime([1,4,6,9],[0,10,20,40],implantCount) +
              // (implantCount <= 6 ? 5 : 10) +
              extraHomeShippingTime,
          };
        }else if([TRY_IN_FIXATING_CLIPS_PLACEMENT_10, TRY_IN_FIXATING_CLIPS_PLACEMENT_14].includes(treatmentId)){
          return {
            ...treatment,
            duration:
              +treatment.duration +
              MapTime([1,4,6,9],[0,10,15,20],implantCount) +
              // (implantCount <= 4 ? 10 : 15) +
              extraHomeShippingTime,
          };
        }

        return {
          ...treatment,
          duration: +treatment.duration + extraHomeShippingTime,
        };
      });
    },
    [
      props.treatment,
      props.treatments,
      props.lowerImplantCount,
      props.upperImplantCount,
    ],
  );

  const options = [
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 4,
      label: "4",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 6,
      label: "6",
    },
  ];

  // normal pc screen
  if (true)
    return (
      <>
        <TreatmentsContainer>
          <Wrapper hide>
            <SelectText disabled={!shouldShowDropDown}>
              <FormattedMessage {...GlobalMessages.selectTreatmentPlan} />
            </SelectText>

            <DropDownWrapper showBorder={shouldShowTreatmentList}>
              <SimpleSearch
                id="treatmentSearchUpper"
                contentId="treatmentSearchContentUpper"
                closable
                placeholder={messages.upperJaw}
                error={props.endProductError}
                value={searchTextUpper}
                onClick={props.onUpperEndProductChanged}
                onValueChanged={handleSearchTextUpperChanged}
                selectedIndex={upperIndex}
                items={upperEndProducts}
                disabled={!shouldShowDropDown}
              />
              {showUpperImplants && (
                <div style={{ marginTop: "15px" }}>
                  <SingleSelectComponent
                    label=<FormattedMessage {...GlobalMessages.implantCount} />
                    value={options.find(
                      x => x.value === props.upperImplantCount,
                    )}
                    onChange={props.onUpperImplantCountChanged}
                    options={options}
                    disabled={!shouldShowDropDown}
                  />
                </div>
              )}
            </DropDownWrapper>
            {showIcon && (
              <MatchIcon
                id="matchIcon"
                onClick={props.onMatchButtonClick}
                disabled={props.upperIndex !== -1 && props.lowerIndex !== -1}
                opacityItem={!shouldShowDropDown}
              >
                {match ? <Match /> : <NoMatch />}
              </MatchIcon>
            )}
            <DropDownWrapper showBorder={shouldShowTreatmentList}>
              <SimpleSearch
                id="treatmentSearchLower"
                contentId="treatmentSearchContentLower"
                closable
                placeholder={messages.lowerJaw}
                error={props.endProductError}
                value={searchTextLower}
                onClick={props.onLowerEndProductChanged}
                onValueChanged={handleSearchTextLower2Changed}
                selectedIndex={lowerIndex}
                items={lowerEndProducts}
                disabled={!shouldShowDropDown}
              />
              {showLowerImplants && (
                <div style={{ marginTop: "15px" }}>
                  <SingleSelectComponent
                    label=<FormattedMessage {...GlobalMessages.implantCount} />
                    value={options.find(
                      x => x.value === props.lowerImplantCount,
                    )}
                    onChange={props.onLowerImplantCountChanged}
                    options={options}
                    disabled={!shouldShowDropDown}
                  />
                </div>
              )}
            </DropDownWrapper>
          </Wrapper>
          <Wrapper hide={!shouldShowTreatmentList}>
            {!shouldShowDropDown && (
              <CancelAppointmentText disabled={!shouldShowDropDown}>
                <FormattedMessage {...GlobalMessages.cancelAppointments} />
              </CancelAppointmentText>
            )}
          </Wrapper>
          {/* treatmentlist */}
          {/* {shouldShowTreatmentList && ( */}
            <TreatmentList
              onDelete={props.onDelete}
              onDisableWagner={props.onDisableWagner}
              onEdit={props.onEdit}
              treatment={props.treatment}
              treatments={treatments}
              onActiveChanged={props.onActiveChanged}
              onExtraTreatment={props.onExtraTreatment}
              wagnerItem={props.wagnerItem}
              wagnerActive={props.wagnerActive}
              screenWidth={small}
            />
          {/* )} */}
        </TreatmentsContainer>

        {props.endProductError && (
          <WarningMessages messages={[messages.mustSelectEndProduct]} />
        )}
      </>
    );

  
}

TreatmentPlan.propTypes = {
  // End product
  treatmentPlan: PropTypes.object,
  onUpperEndProductChanged: PropTypes.func.isRequired,
  onLowerEndProductChanged: PropTypes.func.isRequired,
  upperProductTypes: PropTypes.array.isRequired,
  lowerProductTypes: PropTypes.array.isRequired,
  typeIndex: PropTypes.number,
  lowerIndex: PropTypes.number,
  upperIndex: PropTypes.number,
  endProductError: PropTypes.bool,
  matchingProduct: PropTypes.bool,
  upperEndProductId: PropTypes.any,
  lowerEndProductId: PropTypes.any,
  // Treatments
  treatments: PropTypes.array.isRequired,
  onActiveChanged: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onExtraTreatment: PropTypes.func.isRequired,
  wagnerItem: PropTypes.any,
  wagnerActive: PropTypes.bool,
  onMatchButtonClick: PropTypes.func.isRequired,

  // Active treatment
  treatment: PropTypes.object,
  onDisableWagner: PropTypes.func.isRequired,
};

export default TreatmentPlan;

const MatchIcon = styled.div`
  opacity: ${({ opacityItem }) => (opacityItem ? "0.5" : "1")};
  padding-left: 1rem;
  align-self: center;
  //transform: scale(1.2);
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

const SelectText = styled.div`
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};
  font-weight: bold;
  font-size: large;
  margin-right: auto;
  padding: 1rem;
`;

const CancelAppointmentText = styled.div`
  color: ${({ disabled, theme }) => (disabled ? theme.disabledColor : "black")};
  transform: translateY(-2rem);
  height: 2rem;
  max-width: 32%;
  min-width: 32%;
  width: 20vw;
  font-size: smaller;
  margin-right: auto;
  cursor: pointer;
  padding-top: 0.5rem;
  padding-left: 1rem;
  padding-bottom: 0.5rem;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  ${({ hide, theme }) =>
    !hide && `border-bottom: 1px solid ${theme.borderColor};`};
`;

const DropDownWrapper = styled.div`
  width: 30%;
  min-width: 30%;
  padding: ${({ theme }) => theme.padding}rem;
`;

const TreatmentsContainer = styled.div`
  border: solid 1px ${({ theme }) => theme.borderColor};
  border-radius: 10px;
  width: 100%;
`;

const MobileCancelAppointmentText = styled(CancelAppointmentText)`
  transform: translateY(0);
  width: 50%;
  max-width: 50%;
  min-width: 50%;
`;

const MobileWrapper = styled(Wrapper)`
  justify-content: flex-start;
`;

const MobileDropDown = styled(DropDownWrapper)`
  width: 45%;
  min-width: 45%;
`;
